import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AddFont1 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 1.5C15.25 1.08579 14.9142 0.75 14.5 0.75C14.0858 0.75 13.75 1.08579 13.75 1.5V4.88093H10.3761C9.96192 4.88093 9.62613 5.21672 9.62613 5.63093C9.62613 6.04514 9.96192 6.38093 10.3761 6.38093H13.75V9.76198C13.75 10.1762 14.0858 10.512 14.5 10.512C14.9142 10.512 15.25 10.1762 15.25 9.76198V6.38094L18.3762 6.38099C18.7904 6.381 19.1262 6.04522 19.1262 5.631C19.1263 5.21679 18.7905 4.881 18.3763 4.88099L15.25 4.88094V1.5ZM7.58823 1.25C7.2756 1.25 6.99576 1.44393 6.88599 1.73666L1.42143 16.3088H1C0.585786 16.3088 0.25 16.6446 0.25 17.0588C0.25 17.473 0.585786 17.8088 1 17.8088H1.92367C1.93529 17.8091 1.94689 17.8091 1.95846 17.8088H3.82353C4.23774 17.8088 4.57353 17.473 4.57353 17.0588C4.57353 16.6446 4.23774 16.3088 3.82353 16.3088H3.02343L4.22563 13.1029H9.80492L11.1622 16.3088H10.4118C9.99755 16.3088 9.66176 16.6446 9.66176 17.0588C9.66176 17.473 9.99755 17.8088 10.4118 17.8088H12.2775C12.2888 17.8091 12.3001 17.8091 12.3114 17.8088H16.4847C16.4953 17.809 16.5058 17.809 16.5164 17.8088H17.4412C17.8554 17.8088 18.1912 17.473 18.1912 17.0588C18.1912 16.6446 17.8554 16.3088 17.4412 16.3088H16.9665L15.1728 12.6685C14.9897 12.2969 14.54 12.1442 14.1685 12.3272C13.7969 12.5103 13.6442 12.96 13.8272 13.3315L15.2943 16.3088H12.791L7.61141 4.07419L8.10798 2.75H9.91177C10.326 2.75 10.6618 2.41421 10.6618 2C10.6618 1.58579 10.326 1.25 9.91177 1.25H7.58823ZM9.16988 11.6029H4.78813L6.8463 6.11448L9.16988 11.6029Z"
        fill={color}
      />
    </svg>
  )
})

export default AddFont1
